<template>
  <div class="login-container">
    <div class="login-modal">
      <div class="left-banner"></div>

      <div class="right-form">
        <div class="title">
          <div class="top">Hello,</div>
          <div class="bottom">欢迎使用备考通后台</div>
        </div>
        <div class="wrapper">
          <div class="form" style="width: 100%;">
            <my-input placeholder="请输入登录账号" v-model="mobile"></my-input>
            <my-input
              type="password"
              placeholder="请输入密码"
              v-model="password"
              @keyup.enter.native="handleLogin"
            ></my-input>
            <!-- <input type="text" class="myInput" placeholder="请输入手机号" @input="inputPhoneNumber" /> -->
          </div>
          <div class="login">
            <div @click="handleLogin" class="btnLogin">登录</div>
            <!-- <my-button value="登录" @click="handleLogin"></my-button> -->
          </div>
          <div class="tips">
            <div class="tips-icon"></div>
            <div class="text">忘记密码请联系平台对接人员</div>
          </div>
        </div>
      </div>
    </div>

    <div class="login-bottom-border"></div>
  </div>
</template>

<script>
import goodsApi from "@/api/goods.js";
import userApi from "@/api/common.js";
import MyInput from "@/components/MyInput.vue";
import MyButton from "@/components/MyButton.vue";
import { deepClone } from "@/utils";
export default {
  name: "Login",
  components: {
    MyInput,
    MyButton,
  },
  data() {
    return {
      mobile: "",
      password: "",
      asideList: [], // 跳转之后的侧边栏显示列表
    };
  },
  created() {
    // 给侧边栏显示列表赋值
    this.asideList = deepClone(this.$store.state.asideList);
    this.getTobHideMenu();
  },
  mounted() {
    //  '加载完成');
  },

  methods: {
    inputPhoneNumber(e) {
      //  'value', e.target.value);
    },
    handleMobile(event) {
      //  'event.target.value', event.target.value);
    },
    handleLogin(event) {
      //  '点击登录');
      this.$store
        .dispatch("user/login", {
          username: this.mobile,
          password: this.password,
        })
        .then((res) => {
          if (res.code !== 200) {
            // 登录失败
            this.$message.error(res.message);
          } else { 
            localStorage.setItem("noticeShow", true) 
            // 登录成功
            // 在登录前通过this.$store.state.user.userInfo.role遍历找到对应权限的侧边栏路由，跳转到对应的路由页面
            // for (const item of this.asideList) {
              // console.log("role---", this.$store.state.openTab, this.asideList, this.$store.state.user.userInfo.role)
              // if ( 
              //   this.$store.state.user.userInfo.role == 'nstitutionalteacher' || this.$store.state.user.userInfo.role == 'salespersonr' 
              // ) {
              //   // 如果有子集并且子集有值，则跳转到子集的第一个页面。没有子集直接跳转
              //   if (this.asideList[1].children && this.asideList[1].children.length) {
              //     this.$store.state.openTab = [];
              //     this.$router.push({ path: this.asideList[1].children[0].index });
              //     return;
              //   }
              // } else if(this.$store.state.user.userInfo.role == 'admin' || this.$store.state.user.userInfo.role == 'generaladministrato'){
              //   this.$store.state.openTab = [];
              //   this.$router.push({ path: this.asideList[0].index });
              //   return;
              // } else if( this.$store.state.user.userInfo.role == 'outboundcall') {
              //   this.$store.state.openTab = [];
              //   this.$router.push({ path: this.asideList[4].children[0].index });
              //   return;
              // } else if(this.$store.state == '/helpManualList'){
              //   this.$store.state == '/helpManualList'
              // }
            // }
            // 登录成功
            this.$router.push({ path: "/home" });
          }
        });
    },
    getTobHideMenu() {
      goodsApi.getTobHideMenu().then((res) => {
        if (res.code === 200) {
          console.log("角色列表", res);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 100vh;
  width: 100vw;
  background-color: #e4e8f4;

  .login-modal {
    display: flex;
    justify-content: center;

    width: 1039px;
    height: 563px;

    background-color: #f7f8fb;
    border-radius: 16px;

    .left-banner {
      background-image: url("../../assets/login-banner1.jpg");
      width: 462px;
      height: 100%;
      border-radius: 15px 0 0 15px;
    }

    .right-form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 577px;
      height: 100%;

      .title {
        color: #000000;
        margin-bottom: 53px;
        margin-left: -100px;
        .top {
          font-size: 40px;
          font-weight: 300;
          line-height: 56px;
          margin-bottom: 16px;
        }
        .bottom {
          font-size: 30px;
          font-weight: 300;
          color: #000000;
          line-height: 42px;
        }
      }

      .wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;

        .form {
          display: flex;
          flex-direction: column;
          // gap: 16px;
          margin-bottom: 55px;

          > * {
            margin-bottom: 16px;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        .login {
          margin-bottom: 40px;
        }

        .tips {
          display: flex;
          justify-content: center;
          align-items: center;
          // gap: 8px;

          > * {
            margin-right: 8px;
            &:last-child {
              margin-right: 0;
            }
          }

          .tips-icon {
            width: 18px;
            height: 15px;
            background-image: url("../../assets/icon/login-tips.png");
          }
          .text {
            font-size: 14px;
            font-weight: 300;
            color: #465069;
          }
        }
      }
    }
  }

  .login-bottom-border {
    width: 1041px;
    height: 111px;
    background-image: url("../../assets/login-bottom-border.png");
  }

  .btnLogin {
    width: 415px;
    height: 60px;
    background: #191b27;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
  }
}

/* 针对小屏幕设备（例如手机） */
@media (max-width: 600px) {
  .login-container{
    width: 100%!important; 
    .login-modal{
      width: 94%!important;
      display: block; 
      height: auto;
      padding-bottom: 20px;
      .left-banner {
        width: 100% !important;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        height: 200px;
      } 
      .right-form{
        width: 100%!important; 
        height: auto;
        .title{
          margin-bottom: 20px;
          .top{
            margin-bottom: 16px;
          }
        }

        .wrapper{
          width: 100%!important; 
          .form{
            width: 100%!important;  
            margin-bottom: 20px;
            .input-all{ 
              width: 84%;
              margin: 0 auto;
              margin-bottom: 16px;
            }
          }
          .login{
            width: 100%!important; 
            .btnLogin{
              width: 94%;
              margin: 0 auto;
            }
          }
        }
      }
    }
    .login-bottom-border{
      width: 100%!important; 
      background: none; 
    } 
  } 
}
</style>
